import * as actionTypes from './actionTypes';

export type StateType = {
  readonly clientId: string;
  readonly currentBrand: string;
  readonly enterpriseBrand: string;
  readonly isBrandFilterable: boolean;
  readonly isWhiteListedForCampaign: boolean;
};

export const initialState: StateType = {
  clientId: null,
  currentBrand: null,
  enterpriseBrand: null,
  isBrandFilterable: true,
  isWhiteListedForCampaign: true
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.CLIENT_ID_SET:
      return { ...state, clientId: payload };
    case actionTypes.CURRENT_BRAND_SET:
      return { ...state, currentBrand: payload };
    case actionTypes.ENTERPRISE_BRAND_SET:
      return {
        ...state,
        enterpriseBrand: payload
      };
    case actionTypes.IS_BRAND_FILTERABLE_SET:
      return { ...state, isBrandFilterable: payload };
    case actionTypes.IS_WHITELISTED_FOR_CAMPAIGNS_SET:
      return { ...state, isWhiteListedForCampaign: payload };
    default:
      return state;
  }
};
